import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import SsoLanding from "@/pages/SsoLanding";
import MarketingLayout from "@/layout/MarketingLayout";
import Home from "@/pages/marketing/Home";
import Features from "@/pages/marketing/Features";
import HowItWorks from "@/pages/marketing/HowItWorks";
import Products from "@/pages/marketing/Products";
import Security from "@/pages/marketing/Security";
import Contact from "@/pages/marketing/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Portal from "@/pages/Portal";
import Admin from "@/pages/Admin";
import Superadmin from "@/pages/Superadmin";
import ApiDocs from "@/pages/ApiDocs";
import Rate from "@/pages/Rate";
import Approve from "@/pages/Approve";
import TicketAction from "@/pages/TicketAction";
import Cam from "@/pages/cam/Cam";
import RequirePhoneGate from "@/components/RequirePhoneGate";

function App() {
  return (
    <AuthProvider>
      <div className="App grain">
        <RequirePhoneGate />
        <BrowserRouter>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/features" element={<Features />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/products" element={<Products />} />
              <Route path="/security" element={<Security />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/rate" element={<Rate />} />
            <Route path="/approve" element={<Approve />} />
            <Route path="/ticket-action" element={<TicketAction />} />
            <Route path="/login" element={<Login />} />
            <Route path="/sso" element={<SsoLanding />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/portal/*"
              element={<ProtectedRoute><Portal /></ProtectedRoute>}
            />
            <Route
              path="/admin/*"
              element={<ProtectedRoute roles={["admin", "authority", "technician", "superadmin"]}><Admin /></ProtectedRoute>}
            />
            <Route
              path="/cam/*"
              element={<ProtectedRoute roles={["admin", "authority", "technician", "superadmin"]}><Cam /></ProtectedRoute>}
            />
            <Route
              path="/superadmin/*"
              element={<ProtectedRoute roles={["superadmin"]}><Superadmin /></ProtectedRoute>}
            />
            <Route
              path="/dev/api-docs"
              element={<ProtectedRoute roles={["superadmin"]}><ApiDocs /></ProtectedRoute>}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </div>
    </AuthProvider>
  );
}

export default App;
